import React from "react";
import { Box, Flex, Heading, HStack, Text } from "@chakra-ui/react";

const RiskReviewPageHeader = ({ title, description, actions }) => (
  <Flex
    direction={{ base: "column", md: "row" }}
    justify="space-between"
    align={{ base: "stretch", md: "flex-start" }}
    gap={4}
  >
    <Box>
      <Heading fontSize={{ base: "22px", md: "24px" }} lineHeight="1.2" fontWeight="700" letterSpacing="0">
        {title}
      </Heading>
      {description ? (
        <Text mt={1.5} color="gray.500" fontSize="sm" maxW="780px">
          {description}
        </Text>
      ) : null}
    </Box>
    {actions ? (
      <HStack justify={{ base: "flex-start", md: "flex-end" }} wrap="wrap" spacing={2}>
        {actions}
      </HStack>
    ) : null}
  </Flex>
);

export default RiskReviewPageHeader;
